module.exports = {
      id: "comm-cinema-usage",
      viewBox: "0 0 415.94 49.818",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-cinema",
      toString: function () {
        return this.url;
      }
    }